var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page-choose-project"},[_c('div',{staticClass:"page-body"},[_c('div',{staticClass:"page-body-inner"},[_c('p',{staticClass:"title-welcome"},[_vm._v("\n                SORRY\n            ")]),_c('p',{staticClass:"title-2"},[_vm._v("\n                您暂无权限访问该界面\n            ")])])])])
}]

export { render, staticRenderFns }